import React from 'react'
import { SvgIcon } from '../svg-icon'

/**
 * Define default props as fallback. See SvgIcon base class for propTypes.
 *
 * @static
 * @type {React.defaultProps}
 */
const defaultProps = {
    viewBoxSize: 24
}

/**
 * Stateless function representing a link off icon.
 *
 * @function
 * @param {Object} [props] The component properties
 * @returns {ReactElement} React component markup
 *
 * @see SvgIcon
 * @example
 * <LinkOffIcon width={12} />
 */
const LinkOffIcon = props => (
    <SvgIcon {...props}>
        <path
            d="M13,8c0-0.55,0.45-1,1-1h3c2.75,0,5,2.25,5,5c0,1.82-1,3.41-2.47,4.29l-1.48-1.48C19.18,14.37,20,13.28,20,12
	c0-1.65-1.35-3-3-3h-3C13.45,9,13,8.55,13,8z M17,16.59V17c0.13,0,0.25-0.03,0.38-0.04L17,16.59z M15.8,12.56
	C15.92,12.4,16,12.21,16,12c0-0.55-0.45-1-1-1h-0.76L15.8,12.56z M13.41,13L13.41,13l-2-2h0L3.71,3.29c-0.39-0.39-1.02-0.39-1.41,0
	s-0.39,1.02,0,1.41l2.72,2.72C3.24,8.2,2,9.96,2,12c0,2.75,2.25,5,5,5h3c0.55,0,1-0.45,1-1c0-0.55-0.45-1-1-1H7c-1.65,0-3-1.35-3-3
	c0-1.52,1.15-2.77,2.62-2.96l2.03,2.03C8.28,11.21,8,11.57,8,12c0,0.55,0.45,1,1,1h1.59l8.71,8.71C19.49,21.9,19.74,22,20,22
	s0.51-0.1,0.71-0.29c0.39-0.39,0.39-1.02,0-1.41L13.41,13z"
        />
    </SvgIcon>
)

LinkOffIcon.defaultProps = defaultProps

export { LinkOffIcon }
